import { useAuth } from "../context/AuthContext";

/**
 * Custom hook to get user information
 * @returns {Object} User information object with id, email, name, role, and helper methods
 */
export const useUserInfo = () => {
  const { user, isAuthenticated, isAdmin } = useAuth();

  const getUserInfo = () => {
    return user;
  };

  const isLoggedIn = () => {
    return isAuthenticated;
  };

  const isUserAdmin = () => {
    return isAdmin;
  };

  const hasRole = (role) => {
    return user?.role === role;
  };

  const getUserId = () => {
    return user?.id;
  };

  const getUserEmail = () => {
    return user?.email;
  };

  const getUserName = () => {
    return user?.name;
  };

  const getUserRole = () => {
    return user?.role;
  };

  return {
    user,
    userInfo: user,

    getUserInfo,
    isLoggedIn,
    isUserAdmin,
    hasRole,
    getUserId,
    getUserEmail,
    getUserName,
    getUserRole,

    isAuthenticated,
    isAdmin,
  };
};
